import { MessageSquare, Phone, Mail } from 'lucide-react'
import type { PortalData } from '@/types/portalCliente'

export function PortalClienteSupportSection({ data }: { data: PortalData }) {
  return (
    <section className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-5 space-y-3">
      <h2 className="text-xs font-bold text-accent uppercase tracking-wider flex items-center gap-2">
        <MessageSquare size={14} />
        Precisa de Ajuda?
      </h2>
      <div className="flex flex-wrap gap-3">
        {data.empresa.telefone && (
          <a
            href={`https://wa.me/55${data.empresa.telefone.replace(/\D/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm font-medium hover:bg-emerald-500/20 transition-colors"
          >
            <Phone size={14} />
            WhatsApp
          </a>
        )}
        <a
          href={`mailto:${data.closer.email}`}
          className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium hover:bg-blue-500/20 transition-colors"
        >
          <Mail size={14} />
          {data.closer.email}
        </a>
      </div>
    </section>
  )
}
